import { Grid } from '@material-ui/core';
import { format } from 'date-fns';

// local imports
import { useInputChangeHandler } from 'app/hooks';
import { FormatUtils } from 'app/utils';
import {
  AsyncButton,
  FormInput,
  MaskedInput,
  AddPhoto,
  FormDatePicker,
  FormBasicSelect,
  PasswordInput
} from '../../atoms';

const SystemUserForm = ({
  roles,
  isEdit,
  loading,
  selectedFiles,
  setSelectedFiles,
  removeFile,
  handleDelete,
  deleteLoading,
  isItMe
}) => {
  const { values, preventNonSpecialCharsInput, preventNonNumericInput } = useInputChangeHandler();
  const btnText = isEdit ? 'Kullanıcıyı Güncelle' : 'Kullanıcı Ekle';
  const btnIcon = isEdit ? 'update' : 'person_add';
  const gridItemProps = {
    xs: 12,
    sm: 6,
    lg: !isEdit || isItMe ? 4 : 6
  };

  // "birthdate" Datepicker Max Date
  const legalAge = FormatUtils.getLegalAgeDate();
  const legalAgeMsg = `${format(legalAge, 'dd/MM/yyy')} tarihinden öncesi seçilebilir.`;

  return (
    <div className="flex justify-center items-center">
      {/* Personal Info */}
      <Grid container spacing={2}>
        <Grid item {...gridItemProps}>
          <FormInput
            id="system_user_name"
            label="Ad"
            name="name"
            placeholder="Ad"
            disabled={loading}
            value={values?.name || ''}
            onChange={preventNonSpecialCharsInput}
            maxLength={50}
          />
        </Grid>
        <Grid item {...gridItemProps}>
          <FormInput
            id="system_user_surname"
            label="Soyad"
            name="surname"
            placeholder="Soyad"
            disabled={loading}
            value={values?.surname || ''}
            onChange={preventNonSpecialCharsInput}
            maxLength={50}
          />
        </Grid>
        <Grid item {...gridItemProps}>
          <FormInput
            id="system_user_tckn"
            label="TCKN"
            name="tckn"
            placeholder="TCKN"
            disabled={loading}
            value={values?.tckn || ''}
            onChange={preventNonNumericInput}
            maxLength={11}
          />
        </Grid>

        <Grid item {...gridItemProps}>
          <FormDatePicker
            id="system_user_birthdate"
            name="birthdate"
            label="Doğum Tarihi"
            value={values?.birthdate || ''}
            disabled={loading}
            maxDate={legalAge}
            maxDateMessage={legalAgeMsg}
          />
        </Grid>

        <Grid item {...gridItemProps}>
          <MaskedInput
            disabled={loading}
            type="text"
            mask="+\90 \(999\) 999 99 99"
            maskChar="_"
            alwaysShowMask
            id="id_telephone"
            name="telephone"
            placeholder="Cep Telefonu"
            label="Cep Telefonu"
            value={values?.telephone || ''}
          />
        </Grid>

        <Grid item {...gridItemProps}>
          <FormInput
            id="system_user_email"
            label="E-Posta Adresi"
            name="email"
            placeholder="E-Posta Adresi"
            value={values?.email || ''}
            disabled={loading}
            maxLength={100}
          />
        </Grid>

        <Grid item {...gridItemProps}>
          <FormBasicSelect
            id="system_user_role_id"
            name="role_id"
            label="Yetki"
            value={values?.role_id}
            options={roles || []}
            disabled={loading}
          />
        </Grid>

        <Grid item {...gridItemProps}>
          <FormInput
            id="system_user_duty"
            label="Görev Bilgisi"
            name="title"
            placeholder="Görev Bilgisi"
            value={values?.title || ''}
            disabled={loading}
            maxLength={50}
          />
        </Grid>

        {/* Password */}
        {!isEdit && (
          <Grid container item spacing={2} className="border-t-2 mt-8">
            <Grid item {...gridItemProps}>
              <PasswordInput
                id="password_id"
                name="password"
                label="Parola"
                placeholder="Parola"
                disabled={loading}
                maxLength={12}
              />
            </Grid>

            <Grid item {...gridItemProps}>
              <PasswordInput
                id="password_confirmation_id"
                name="password_confirmation"
                label="Parola Onay"
                placeholder="Parola onay"
                disabled={loading}
                maxLength={12}
              />
            </Grid>
          </Grid>
        )}

        {/* Photo - Action Buttons */}
        <Grid item xs={12}>
          <AddPhoto
            id="system_user_photo"
            label="Profil Fotoğrafı"
            loading={loading}
            selectedFiles={selectedFiles}
            setSelectedFiles={setSelectedFiles}
            name="photo"
            removeFile={removeFile}
          />
        </Grid>

        {/* Action buttons */}
        <Grid item xs={12} className="flex justify-end">
          {isEdit && (
            <AsyncButton
              disabled={isItMe || loading || deleteLoading}
              icon="delete"
              text="Kullanıcıyı Sil"
              type="button"
              loading={deleteLoading}
              handleClick={handleDelete}
              className="bg-red-400 text-white hover:bg-red-600 mr-16"
            />
          )}
          <AsyncButton
            icon={btnIcon}
            text={btnText}
            disabled={deleteLoading}
            loading={loading}
            className="bg-green-400 text-white hover:bg-green-600"
          />
        </Grid>
      </Grid>
    </div>
  );
};

export default SystemUserForm;
